module.exports = __webpack_public_path__ + "static/media/Merriweather-Bold.d9f26381.ttf";